import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NavbarComponent } from './navbar/navbar.component';
import { MenuSidebarComponent } from './menu-sidebar/menu-sidebar.component';
import { RouterModule } from '@angular/router';
import { ComponentsModule } from '../components/components.module';

@NgModule({
  declarations: [NavbarComponent, MenuSidebarComponent],
  imports: [CommonModule, RouterModule, ComponentsModule],
  exports: [NavbarComponent],
})
export class SharedModule { }
